import { StateCreator } from 'zustand';
import { IAppStore } from '../../../IAppStore';
import TopicLayerFilterSlice, { TopicLayerFilterProps } from './TopicLayerFilterSlice';

export const defaultTopicLayerFilterProps: TopicLayerFilterProps = {
  topicLayerFilter: '',
  topicLayerCategoryFilter: ['topicmaps.geo.ag.ch', 'wms.geo.ag.ch', 'wms.geo.admin.ch'],
  sortOrder: 'ascending',
};

const createTopicLayerFilterSlice: StateCreator<
  IAppStore,
  [],
  [],
  TopicLayerFilterSlice
> = (set, get) => ({
  ...defaultTopicLayerFilterProps,
  setTopicLayerFilter: (text: string) => set({ topicLayerFilter: text }),
  toggleTopicLayerFilter: (category: string) => {
    const newCategories = get().topicLayerCategoryFilter.includes(category)
      ? get().topicLayerCategoryFilter.filter((c) => c !== category)
      : [...get().topicLayerCategoryFilter, category];
    set({ topicLayerCategoryFilter: newCategories });
  },
  toogleSort: () =>
    set({ sortOrder: get().sortOrder === 'ascending' ? 'descending' : 'ascending' }),
});

export default createTopicLayerFilterSlice;
